import React, { useContext } from 'react';
import { ASSET_TYPE } from '../../../react-three-components/sceneAsset';
import { OBJECT_TYPE_NAMES } from 'src/types/assetTypes';
import { ThemeContext } from 'pages/_app';
import { getTextColor } from 'src/constants/theme';

export default function ObjectName({ assetType, selectedModel }) {
  const { isDark } = useContext(ThemeContext);
  let typeName;

  switch (assetType) {
    case ASSET_TYPE.GLTF.OTHER:
      if (selectedModel?.props?.asset?.isPortal) {
        typeName = OBJECT_TYPE_NAMES.PORTAL;
      } else {
        typeName = OBJECT_TYPE_NAMES.ASSET;
      }
      break;
    case ASSET_TYPE.MISC.LIGHT:
      typeName = OBJECT_TYPE_NAMES.LIGHT;
      break;
    case ASSET_TYPE.MISC.POSITIONAL_AUDIO:
      typeName = OBJECT_TYPE_NAMES.POSITIONAL_AUDIO;
      break;
    case ASSET_TYPE.PRIMITIVE_TEXTURE.IMAGE_PLANE:
      typeName = OBJECT_TYPE_NAMES.IMAGE_PLANE;
      break;
    case ASSET_TYPE.PRIMITIVE_TEXTURE.SCREEN_SHARE:
      typeName = OBJECT_TYPE_NAMES.SCREEN_SHARE;
      break;
    case ASSET_TYPE.PRIMITIVE_TEXTURE.VIDEO_PLANE:
      typeName = OBJECT_TYPE_NAMES.VIDEO_PLANE;
      break;
    case ASSET_TYPE.AI_AVATARS:
      typeName = OBJECT_TYPE_NAMES.AI_AVATAR;
      break;
    case ASSET_TYPE.NPC_AVATARS:
      typeName = OBJECT_TYPE_NAMES.NPC_AVATAR;
      break;
  }

  return <p style={{ color: getTextColor(isDark) }}>{`Type: ${typeName}`}</p>;
}
